// @flow
import React from 'react';
import AbstractReactComponent from './../AbstractReactComponent';
import {UncontrolledTooltip, Label, FormGroup} from "reactstrap"
import classNames from 'classnames';
import TranslateComponent from './TranslateComponent'
import FieldGrid from './FieldGrid'
import newId from "./newId";

class FieldForm extends AbstractReactComponent {
    static contextTypes = {
        formPath: React.PropTypes.string,
        horizontal: React.PropTypes.bool,
        inline: React.PropTypes.bool
    };

    static PropTypes = {
        hasFeedback: React.PropTypes.bool,  // pokud je true, zobrazuje se prvek s feedbackem podle toho, zda je chybný nebo ne, pokud je prvek upraven a je bez chyby, zobrazuje se jako success, pokud má focus, není zobrazena ikona check, pokud má chybu, zobrazuje se jako danger
        color: React.PropTypes.string,  // barva/stav pro form group, např. success
        state: React.PropTypes.string,  // stav pro input, např. success
        inputLabelOffset: React.PropTypes.bool, // pokud je uvedeno a je label na false, dá se do inpit class offset z label tak, aby byl input zarovnaný s ostatními hodnotami, které mají label, pokud je false, vezme se pro input class hodnota definovaná v noLabelInputClass
        inline: React.PropTypes.bool,
        required: React.PropTypes.bool,
        error: React.PropTypes.string,  // překrytí chyby - v případě vlastního zpracování chyb
        check: React.PropTypes.bool,  // pokud je true, jedná se o field typu checkbox
        groupClass: React.PropTypes.object,
        labelRight: React.PropTypes.bool,   // má být label fieldu napravo od něj?
        labelInField: React.PropTypes.bool,   // má být label renderovaný až ve fieldu, bude pak předaný jako label do fieldu přes props?
        labelClass: React.PropTypes.oneOfType([
            React.PropTypes.string,
            React.PropTypes.object
        ]),
        inputClass: React.PropTypes.oneOfType([
            React.PropTypes.bool,
            React.PropTypes.object
        ]),
        noLabelInputClass: React.PropTypes.oneOfType([
            React.PropTypes.bool,
            React.PropTypes.object
        ]),
        field: React.PropTypes.oneOfType([
            React.PropTypes.object,
            React.PropTypes.func,
        ]),
        row: React.PropTypes.bool,
        label: React.PropTypes.oneOfType([
            React.PropTypes.bool,
            React.PropTypes.string
        ]),
        title: React.PropTypes.oneOfType([
            React.PropTypes.bool,
            React.PropTypes.string
        ]),
    };

    static defaultProps = {
        labelInField: false,
        groupClass: {},
        inline: false,
        label: true,
        labelClass: {xs: 12, sm: 4, md: 4, lg: 4, xl: 4},
        inputClass: {xs: 12, sm:8, md: 8, lg: 8, xl: 8},
        noLabelInputClass: {xs: 12, sm:12, md: 12, lg: 12, xl: 12},
    };

    constructor(props) {
        super(props);
        this.uniqueId = newId();
    }

    render() {
        const { formPath, horizontal } = this.context;

        const {
            color,
            state,
            input,
            error,
            check,
            meta,
            name,
            label,
            checkboxLabel,
            title,
            field,
            inline,
            required,
            labelInField,
            labelClass,
            inputClass,
            hasFeedback,
            fieldLabelText,
            ...other
        } = this.props;

        let labelInFieldComponent;
        if (labelInField === true) {
            labelInFieldComponent = fieldLabelText;
        } else if (labelInField) {
            labelInFieldComponent = labelInField;
        } else {
            labelInFieldComponent = null;
        }

        const hasError = ((this.props.meta && this.props.meta.touched && this.props.meta.error) ? true : false) || (this.props.error ? true : false);

        let errorText;
        // const hasError = (meta && meta.touched && meta.error) || (error);
        if (hasError) {
            errorText = error || (meta ? meta.error : null);
        }
        if (typeof errorText === "object") {
            console.error("Chyba při zobrazení chybové hlášky k fieldu", this.props, "pravděpodobně je na formuláři validace na field, který není zobrazen");
            errorText = "???";
        }

        // Feedback
        let showFeedback = false;
        let feedbackColor;
        let feedbackState;
        if (hasFeedback) {
            if (meta.touched && !errorText) {
                if (meta.active) {
                    showFeedback = true;
                    feedbackColor = "success";
                } else {
                    showFeedback = true;
                    feedbackColor = "success";
                    feedbackState = "success";
                }
            } else if (errorText) {
                showFeedback = true;
                feedbackColor = "danger";
                feedbackState = "danger";
            } else {
                // nic
            }
        }
        let useState;
        let useColor;
        if (showFeedback) {
            useState = state || feedbackState;
            useColor = color || feedbackColor;
        } else {
            useState = state;
            useColor = color;
        }

            // --
        if (horizontal) {
            const {label, color, check, labelInField, labelClass, labelPosition, meta, groupClass, inline, inputClass, noLabelInputClass, field, required, title, className, input, ...otherProps} = this.props;
            const useInputClass = label === false ? noLabelInputClass : inputClass;

            return <FieldGrid
                label={label === true ? input.name : label}
                check={check}
                title={title}
                inlineErrorText={inline ? errorText : null}

                inputClass={useInputClass}
                checkboxLabel={checkboxLabel}
                labelPosition={labelPosition}
                required={required}
                labelClass={labelClass}

                className={classNames(className, {error: hasError, inline, required})}
            >
                {React.createElement(field, {
                    ...input,
                    ...otherProps,
                    state: useState
                })}
                {!inline && hasError && <span className="error-text">{errorText}</span>}
            </FieldGrid>;
        }


        // let titleComponent;
        // if (title === true) {
        //     titleComponent = fieldLabelText ? fieldLabelText : null;
        // } else if (title) {
        //     titleComponent = title;
        // }


        // if (inline && hasError) {
        //     titleComponent = errorText; // TODO spojit error a titulek
        // }

        // ----------------------------------

        const inlineErrorText = inline ? errorText : null;
        const customFieldProps = {};    // další doplňující, např. pro checkbox apod.
        let labelComponent;
        const useLabel = label || checkboxLabel;
        if (Array.isArray(useLabel) || typeof useLabel === "string") {
            labelComponent = <TranslateComponent title={title} message={useLabel} component={check ? "span" : Label} />;
        } else if (useLabel === true) {
            const useName = name || (input ? input.name : null);

            if (!useName) {
                throw new Error('Field has no name!!');
            }

            labelComponent = <TranslateComponent title={title} message={useName} component={check ? "span" : Label} />;
        } else {
            labelComponent = useLabel
        }

        if (check) {
            customFieldProps.label = labelComponent;
            labelComponent = null;
        }

        if (inlineErrorText) {
            customFieldProps.id = this.uniqueId;
        }
        const fieldProps = {
            ...input,
            ...other,
            ...customFieldProps,
            title,
            labelInFieldComponent,
        };
        fieldProps.className = classNames(fieldProps.className, {
            [useState ? `form-control-${useState}` : ``]: useState ? true : false
        });
        let childField = React.createElement(field, fieldProps);
        if (inlineErrorText) {
            childField = <div>
                <UncontrolledTooltip tether={{classes: {enabled: "show form-error-field-tether"}}} className="error-text" target={this.uniqueId}>{inlineErrorText}</UncontrolledTooltip>
                {childField}
            </div>
        }

        return <FormGroup color={useColor} check={check} className={classNames({error: hasError, required, inline})}>
            {!inline && labelComponent}
            {childField}
            {!inline && hasError && <span className="error-text">{errorText}</span>}
        </FormGroup>

    }
}

export default FieldForm;
